<template>
    <div class="layout-footer">
        <a id="footerlogolink">
          <img id="footer-logo"  :src="require(`@/assets/images/prohealth.png`)" alt="pha-logo-footer" />
        </a>
    </div>
</template>

<script>
import { mapGetters } from "vuex";


export default {
  name: 'AppFooter',
  computed: {
    ...mapGetters("auth", ["companyLogo","isGodUser"]),
  },

};
</script>

<style scoped>
.footer-logo {
  width: 100px !important;   /* override theme */
  height: 50px !important;
  object-fit: contain;       /* keeps aspect ratio */
  display: block; 
}
</style>
